import { GET_APP_USERS, GET_APP_USERS_FAILED, SET_LOADING_STATUS } from 'redux/types';

const INIT_STATE = {
  appUsersList: [],
  isLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_LOADING_STATUS:
      return { ...state, isLoading: action.payload };
    case GET_APP_USERS:
      return { ...state, appUsersList: action.payload, isLoading: false };
    case GET_APP_USERS_FAILED:
      return { ...state, appUsersList: [], isLoading: false };
    default:
      return { ...state };
  }
};
